import { render, staticRenderFns } from "./practiceManagement.vue?vue&type=template&id=221f4e67&scoped=true&"
import script from "./practiceManagement.vue?vue&type=script&lang=js&"
export * from "./practiceManagement.vue?vue&type=script&lang=js&"
import style0 from "./practiceManagement.vue?vue&type=style&index=0&id=221f4e67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221f4e67",
  null
  
)

export default component.exports